import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";

// store
import { alertAtom } from "store/alert/atom";

/**
 * @file 얼럿 커스텀 훅
 */
const useAlert = () => {
  const [alert, setAlert] = useRecoilState(alertAtom);
  const [needsCleanup, setNeedsCleanup] = useState(false);

  const noti = (message, ok) => {
    const promise = new Promise((resolve, reject) => {
      const isCustomMessage = typeof message === "function";

      setAlert({
        message: isCustomMessage ? undefined : message,
        renderMessage: isCustomMessage ? message : undefined,
        isOpen: true,
        resolve,
        reject,
        ok,
      });
      setNeedsCleanup(true);
    });
    const reset = () => {
      setAlert({
        message: "",
        isOpen: false,
        resolve: null,
        reject: null,
        ok: "",
      });
      setNeedsCleanup(false);
    };

    return promise.then(
      () => {
        reset();
        return true;
      },
      () => {
        reset();
        return false;
      }
    );
  };

  useEffect(() => {
    // cleanup
    return () => {
      if (alert.reject && needsCleanup) {
        alert.reject();
      }
    };
  }, [alert, needsCleanup]);

  return {
    ...alert,
    noti,
  };
};

export default useAlert;
